/** @typedef {import('../index.js').BaseDocData} BaseDocData */
import * as Yup from 'yup';
import YupFirestoreTimestamp from '../yupFirestoreTimestamp.js';

export const inventoryByProductVersionSchema = Yup.object().shape({
  productDocId: Yup.string().required('productDocId is required'),
  productVersionId: Yup.string().required('productVersionId is required'),
  sku: Yup.string().required('sku is required'),
  onHand: Yup.number().integer().min(0).default(0)
    .required('onHand is required'),
  incomingSupply: Yup.number().integer().min(0).default(0)
    .required('incomingSupply is required'),
  committedDemand: Yup.number().integer().min(0).default(0)
    .required('committedDemand is required'),
  netPosition: Yup.number().integer().default(0)
    .required('netPosition is required'),
  updatedAt: YupFirestoreTimestamp.nullable(),
});

/**
 * @typedef {Yup.InferType<typeof inventoryByProductVersionSchema>} InventoryByProductVersionSchema
 * @typedef {BaseDocData & InventoryByProductVersionSchema} InventoryByProductVersionDocData
 */

export default class InventoryByProductVersion {
  /** @type {InventoryByProductVersionDocData['validation']} */ validation = 'passed';

  constructor({
    id,
    productDocId,
    productVersionId,
    sku,
    onHand = 0,
    incomingSupply = 0,
    committedDemand = 0,
    netPosition = onHand + incomingSupply - committedDemand,
    updatedAt,
  }) {
    const validatedData = inventoryByProductVersionSchema.validateSync({
      productDocId,
      productVersionId,
      sku,
      onHand,
      incomingSupply,
      committedDemand,
      netPosition,
      updatedAt,
    });

    this.id = id || null;
    Object.assign(this, validatedData);
  }

  toFirestore({ serverTimestamp }) {
    return {
      productDocId: this.productDocId,
      productVersionId: this.productVersionId,
      sku: this.sku,
      onHand: this.onHand,
      incomingSupply: this.incomingSupply,
      committedDemand: this.committedDemand,
      netPosition: this.netPosition,
      updatedAt: serverTimestamp(),
    };
  }

  static fromFirestore(docData) {
    return new InventoryByProductVersion(docData);
  }
}
